/**
 * Chemin de la fiche d'un Produit.
 *
 * `ProductCardDto.id` est un identifiant composite `"<dmc>:<externalId>"`, et
 * la route n'attend que la seconde moitié. Le découpage était recopié dans les
 * deux enveloppes de listing, sous la forme `id.split(':').slice(1).join(':')`
 * — une expression dont on ne devine ni ce qu'elle produit, ni pourquoi le
 * `join` recolle ce que le `split` vient de séparer (l'`externalId` peut lui
 * aussi contenir un `:`).
 */
export function productExternalId(compositeId: string): string {
    return compositeId.split(':').slice(1).join(':');
}

export function productFicheHref(dmcSlug: string, category: string, externalId: string): string {
    return `/dmcs/${dmcSlug}/products/${category}/${encodeURIComponent(externalId)}`;
}

export function productDetailHref(dmcSlug: string, category: string, compositeId: string): string {
    return productFicheHref(dmcSlug, category, productExternalId(compositeId));
}
